

<template>
  <div>
    <button class="primery-button" @click="openModal">
      <span class="button-text">
        {{ $t('button.consultation') }}
      </span>
    </button>
    <ConsultationModal 
      v-if="isModalOpen" 
      @closeModal="closeModal" 
      @formSubmitted="handleFormSuccess" 
    />
    <SuccessModal 
      v-show="showSuccessModal" 
      :visible="showSuccessModal" 
      :message="'Форма успешно отправлена!'" 
      @close="closeSuccessModal" 
    />
  </div>
</template>

<script>
import ConsultationModal from '@/components/Consultation/ConsultationModal.vue';
import SuccessModal from '@/components/Consultation/SuccessModal.vue';

export default {
  name: 'OpenModalButton',
  components: {
    ConsultationModal,
    SuccessModal
  },
  data() {
    return {
      isModalOpen: false,
      showSuccessModal: false
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    handleFormSuccess() {
      this.showSuccessModal = true;
      this.isModalOpen = false;
    },
    closeSuccessModal() {
      this.showSuccessModal = false;
    }
  }
};
</script>
